module.exports = __webpack_public_path__ + "img/download.9b619729.svg";